import Corset from './Corset';

export default Corset;
